import { render, staticRenderFns } from "./formNode.vue?vue&type=template&id=b2715f9c&"
import script from "./formNode.vue?vue&type=script&lang=js&"
export * from "./formNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports